export default __webpack_public_path__ + "static/media/img-0588-poland-full-face.e0fb2caf.png";